import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { AuthVerifyRequestBody, AuthVerifyResponse } from "./types";

export class AuthVerifyAPI extends BaseAPI<
  AuthVerifyRequestBody,
  AuthVerifyResponse
> {
  protected route = ApiRoutes.auth.verify;
  protected method = RequestMethod.POST;
  protected displayError = false;
}
